import { ComputedStaticTextInput, StaticInput } from '@framework/form';
import React from 'react';
import { ConfigFormItem } from '../../../../../../ui/form/ConfigFormItem';
import { PaymentRowLogic } from '../PaymentRowLogic';

export interface IPaymentRowReportFieldProps {
  readonly: boolean;
  name: string;
  label: string;
  value: number | null;
}

/**
 * Renderizza e valorizza nel form i campi di riepilogo di una riga di pagamento
 * (imponibile, IVA, totale).
 * È fondamentale per poter inserire nel form i valori calcolati dalla logica di business.
 */
export function PaymentRowReportField(props: IPaymentRowReportFieldProps) {
  const { readonly, label, value, name } = props;

  return (
    <ConfigFormItem
      name={name}
      label={label}
      readonly={readonly}
      style={{ maxWidth: 140 }}
      layout={{ removeMargin: true }}
    >
      {/* Mettiamo un componente di placeholder così da mostrare qualcosa all'utente */}
      {value == null && <StaticInput value={'- €'} removeBorder />}
      <ComputedStaticTextInput
        name={name}
        value={value}
        readonly={readonly}
        renderFormat={value => PaymentRowLogic.formatCurrency(value)}
        removeBorder
        hidden={value == null}
      />
    </ConfigFormItem>
  );
}
